export default {
    lang: {
        name: 'BGG Rank'
    }
}